export interface Article {
  id: string;
  title: string;
  slug: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
  tags: string[];
}

export interface Category {
  name: string;
  slug: string;
  description: string;
  icon: string;
  articleCount: number;
  image: string;
}

export const categories: Category[] = [
  {
    name: '竞技射击',
    slug: 'competitive-shooting',
    description: '精准瞄准，极限反应，在枪林弹雨中脱颖而出',
    icon: 'ri-crosshair-line',
    articleCount: 28,
    image: 'https://readdy.ai/api/search-image?query=Competitive%20shooting%20esports%20arena%20with%20dramatic%20lighting%20and%20intense%20atmosphere%2C%20warm%20orange%20and%20gold%20accents%2C%20professional%20gaming%20setup%2C%20cinematic%20composition%2C%20dark%20background%20with%20spotlight%20effects&width=800&height=500&seq=cat-shooting&orientation=landscape',
  },
  {
    name: '策略竞技',
    slug: 'strategy-games',
    description: '运筹帷幄，智谋对决，步步为营决胜千里',
    icon: 'ri-brain-line',
    articleCount: 35,
    image: 'https://readdy.ai/api/search-image?query=Strategy%20game%20tournament%20scene%20with%20players%20deep%20in%20thought%2C%20warm%20amber%20lighting%2C%20professional%20esports%20environment%2C%20dramatic%20cinematic%20style%2C%20golden%20hour%20glow%20effect&width=800&height=500&seq=cat-strategy&orientation=landscape',
  },
  {
    name: 'MOBA竞技',
    slug: 'moba-games',
    description: '团队协作，技能连招，5v5巅峰对决燃爆全场',
    icon: 'ri-team-line',
    articleCount: 42,
    image: 'https://readdy.ai/api/search-image?query=MOBA%20esports%20competition%20with%20teams%20facing%20off%2C%20epic%20arena%20atmosphere%2C%20warm%20golden%20lighting%2C%20dramatic%20stage%20effects%2C%20professional%20gaming%20tournament%20setup&width=800&height=500&seq=cat-moba&orientation=landscape',
  },
  {
    name: '格斗竞技',
    slug: 'fighting-games',
    description: '拳拳到肉，连招制敌，一决高下的热血对决',
    icon: 'ri-boxing-line',
    articleCount: 19,
    image: 'https://readdy.ai/api/search-image?query=Fighting%20game%20tournament%20with%20intense%20matchup%2C%20dramatic%20stage%20lighting%2C%20warm%20orange%20and%20red%20atmosphere%2C%20esports%20arena%2C%20cinematic%20composition&width=800&height=500&seq=cat-fighting&orientation=landscape',
  },
  {
    name: '竞速挑战',
    slug: 'racing-challenge',
    description: '极速飞驰，弯道超车，分秒之间的速度与激情',
    icon: 'ri-speed-up-line',
    articleCount: 15,
    image: 'https://readdy.ai/api/search-image?query=Racing%20game%20esports%20competition%20with%20speed%20effects%2C%20dynamic%20motion%20blur%2C%20warm%20amber%20lighting%2C%20professional%20gaming%20setup%2C%20dramatic%20cinematic%20style&width=800&height=500&seq=cat-racing&orientation=landscape',
  },
  {
    name: '休闲竞技',
    slug: 'casual-games',
    description: '轻松有趣，老少皆宜，随时随地来一场欢乐对决',
    icon: 'ri-gamepad-line',
    articleCount: 23,
    image: 'https://readdy.ai/api/search-image?query=Casual%20competitive%20gaming%20event%20with%20colorful%20atmosphere%2C%20warm%20inviting%20lighting%2C%20players%20enjoying%20games%20together%2C%20friendly%20competition%20vibe%2C%20modern%20gaming%20lounge&width=800&height=500&seq=cat-casual&orientation=landscape',
  },
];

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '2026年8月射击大赛冠军专访：从草根到王者的逆袭之路',
    slug: '2026-august-shooting-champion-interview',
    excerpt: '在刚刚结束的8月射击大赛中，一位名不见经传的选手以黑马之姿横扫全场。我们独家专访了这位新晋冠军，听他讲述背后的故事。',
    content: `<p>在刚刚结束的2026年8月射击大赛中，一位名不见经传的选手"夜鹰"以黑马之姿横扫全场，连续击败三位往届冠军，最终以绝对优势夺得本次大赛桂冠。</p>
    <h2>从零开始的竞技之路</h2>
    <p>"我接触竞技射击其实只有一年半的时间。"夜鹰在接受采访时坦言，"最开始只是朋友推荐来17c.cc试试看，没想到第一次参赛就被虐得体无完肤。"</p>
    <p>那次惨败反而激发了他的斗志。此后每天，他都会花至少4个小时在17c.cc平台上训练，研究每一位顶尖选手的比赛录像，分析他们的走位习惯和射击节奏。</p>
    <h2>冠军的秘诀</h2>
    <p>当被问及夺冠秘诀时，夜鹰分享了三个关键点：</p>
    <ul>
    <li><strong>稳定的心态</strong>：无论局势如何，保持冷静是最高准则</li>
    <li><strong>充分的准备</strong>：赛前研究每一位可能遇到的对手的打法</li>
    <li><strong>持续的练习</strong>：没有捷径，唯有每天坚持训练</li>
    </ul>
    <h2>对新手的话</h2>
    <p>"17c.cc每日大赛最大的魅力就是人人都有机会。"夜鹰说，"这里的匹配机制非常公平，你会遇到水平相当的对手，也会有机会挑战高手。只要坚持参与，进步是必然的。"</p>
    <p>8月大赛的总奖金池高达50,000元，夜鹰一人独揽15,000元冠军奖金。但他表示，奖金只是锦上添花，真正珍贵的是在竞技过程中收获的成长和友谊。</p>`,
    category: '竞技射击',
    categorySlug: 'competitive-shooting',
    author: '17c.cc赛事编辑',
    date: '2026-08-03',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Esports%20champion%20holding%20trophy%20in%20dramatic%20lighting%2C%20warm%20golden%20atmosphere%2C%20professional%20gaming%20arena%20background%2C%20cinematic%20portrait%20style%2C%20achievement%20and%20victory%20mood&width=1200&height=600&seq=article-1&orientation=landscape',
    tags: ['冠军专访', '射击大赛', '竞技技巧', '玩家故事'],
  },
  {
    id: 'article-2',
    title: '策略竞技进阶指南：5个让你胜率翻倍的核心技巧',
    slug: 'strategy-game-advanced-guide',
    excerpt: '想要在策略竞技中脱颖而出？本文总结了5个经过实战验证的核心技巧，帮助你在17c.cc每日大赛中大幅提升胜率。',
    content: `<p>策略竞技是17c.cc每日大赛中最受欢迎的赛事类型之一。与纯粹依赖反应速度的竞技不同，策略竞技更考验选手的思维深度和决策能力。</p>
    <h2>技巧一：开局布局决定成败</h2>
    <p>很多新手选手容易犯的错误是开局随意行动。高手之间的对决，开局前30秒的布局往往就决定了整场比赛70%的走向。建议在赛前就规划好3-5套不同的开局方案，根据对手的风格灵活切换。</p>
    <h2>技巧二：资源管理是核心</h2>
    <p>无论是什么类型的策略竞技，资源管理永远是核心命题。一个简单的原则：永远不要让你的资源闲置超过30秒。每个资源单位都应该在发挥作用——要么在产出，要么在进攻，要么在防守。</p>
    <h2>技巧三：信息差就是优势</h2>
    <p>在策略竞技中，掌握对手不知道的信息就是最大的优势。养成每30秒侦察一次对手动向的习惯，同时注意隐藏自己的关键信息。</p>
    <h2>技巧四：节奏掌控</h2>
    <p>优秀的策略选手都是节奏大师。他们知道什么时候该快攻，什么时候该稳守，什么时候该虚张声势。学习识别比赛的不同阶段，并调整相应的策略节奏。</p>
    <h2>技巧五：复盘是最好的老师</h2>
    <p>17c.cc平台提供了完整的比赛回放功能。每场大赛结束后，花15分钟复盘自己的比赛，找出3个可以改进的点，这比盲目打10场比赛更有效。</p>`,
    category: '策略竞技',
    categorySlug: 'strategy-games',
    author: '17c.cc战术分析师',
    date: '2026-08-02',
    readTime: '12分钟',
    image: 'https://readdy.ai/api/search-image?query=Strategic%20game%20analysis%20with%20chess-like%20board%20and%20tactical%20diagrams%2C%20warm%20amber%20lighting%2C%20intellectual%20atmosphere%2C%20professional%20study%20environment%2C%20cinematic%20top-down%20view&width=1200&height=600&seq=article-2&orientation=landscape',
    tags: ['策略指南', '竞技技巧', '胜率提升', '进阶教程'],
  },
  {
    id: 'article-3',
    title: 'MOBA大赛S3赛季前瞻：新英雄、新地图、新规则全解析',
    slug: 'moba-season3-preview',
    excerpt: '17c.cc每日大赛MOBA赛事即将迎来S3赛季！新英雄登场、地图重做、赛制升级，所有变化一文读懂。',
    content: `<p>17c.cc每日大赛MOBA赛事S3赛季将于8月15日正式开启！本次赛季更新堪称史上最大规模，让我们一起来看看都有哪些重磅变化。</p>
    <h2>三位新英雄登场</h2>
    <p>S3赛季将迎来三位全新英雄——"炎龙骑士"、"冰霜女巫"和"暗影刺客"。每位英雄都拥有独特的技能机制，将为赛场带来全新的战术可能性。</p>
    <p>其中"炎龙骑士"定位为前排坦克，拥有强大的开团能力和持续灼烧伤害；"冰霜女巫"是控制型法师，能够大范围减速和冻结敌人；"暗影刺客"则是高爆发的收割型刺客，适合喜欢激进打法的玩家。</p>
    <h2>地图全面重做</h2>
    <p>经典地图"荣耀战场"在S3赛季经历了全面重做。新增了上下路各一个的"战术传送点"，以及地图中央的"龙魂祭坛"。这些新增元素将极大丰富战术选择，让比赛更加精彩纷呈。</p>
    <h2>赛制升级</h2>
    <p>S3赛季采用全新的双败淘汰赛制，给予选手更多容错空间。同时，每日大赛的奖励也全面升级——冠军奖金提升至20,000元，前8名均有丰厚奖励。</p>`,
    category: 'MOBA竞技',
    categorySlug: 'moba-games',
    author: '17c.cc赛事解说',
    date: '2026-08-01',
    readTime: '10分钟',
    image: 'https://readdy.ai/api/search-image?query=MOBA%20game%20new%20season%20reveal%20with%20epic%20character%20silhouettes%2C%20dramatic%20stage%20presentation%2C%20warm%20golden%20spotlight%20effects%2C%20esports%20arena%2C%20cinematic%20wide%20shot&width=1200&height=600&seq=article-3&orientation=landscape',
    tags: ['MOBA', 'S3赛季', '新英雄', '赛制更新'],
  },
  {
    id: 'article-4',
    title: '格斗大赛月度冠军"铁拳王"教你连招基本功',
    slug: 'fighting-game-combo-guide',
    excerpt: '连续三个月蝉联17c.cc格斗大赛冠军的"铁拳王"，首次公开分享他的连招训练方法和实战心得。',
    content: `<p>在17c.cc每日大赛格斗赛事中，"铁拳王"是一个传奇般的名字——他已经连续三个月蝉联月度冠军，保持着惊人的47连胜纪录。</p>
    <h2>连招的基础理念</h2>
    <p>"很多人以为连招就是手速快，"铁拳王说，"但实际上，连招的核心是节奏感和时机判断。手速只是锦上添花。"</p>
    <p>他建议新手从最基础的3-5连开始练习，不要急于追求华丽的超长连招。把基础连招练到肌肉记忆的程度，在实战中才能稳定发挥。</p>
    <h2>每日训练计划</h2>
    <p>铁拳王分享了他的日常训练计划：每天早上30分钟基础连招练习，中午观看3场高手对战录像，晚上参加17c.cc每日大赛实战检验训练成果。</p>
    <p>"17c.cc每日大赛最棒的地方是你能遇到各种风格的对手，这是最好的实战训练场。"</p>`,
    category: '格斗竞技',
    categorySlug: 'fighting-games',
    author: '17c.cc格斗专栏',
    date: '2026-07-30',
    readTime: '7分钟',
    image: 'https://readdy.ai/api/search-image?query=Fighting%20game%20champion%20demonstrating%20combos%2C%20dynamic%20action%20pose%2C%20warm%20dramatic%20lighting%2C%20arcade%20style%20background%2C%20intense%20competition%20mood&width=1200&height=600&seq=article-4&orientation=landscape',
    tags: ['格斗技巧', '连招教程', '冠军心得', '新手入门'],
  },
  {
    id: 'article-5',
    title: '竞速大赛新赛道"极光之路"深度解析与跑法攻略',
    slug: 'racing-new-track-guide',
    excerpt: '17c.cc竞速大赛最新赛道"极光之路"上线！本文带来全网最详细的赛道分析和最佳跑法攻略。',
    content: `<p>17c.cc竞速大赛最新赛道"极光之路"已于本周正式上线。这条以北极极光为灵感的赛道，全长8.7公里，包含23个弯道和5个跳跃点，是目前技术难度最高的赛道之一。</p>
    <h2>赛道分段解析</h2>
    <p>赛道可分为三个主要段落：起始段（0-2.5km）以高速直道为主，适合建立初期优势；中段（2.5-6km）是连续的S弯和发卡弯，是拉开差距的关键区域；末段（6-8.7km）包含两个高风险跳跃点，是翻盘的最后机会。</p>
    <h2>最佳跑法推荐</h2>
    <p>经过反复测试，我们推荐在中段连续弯道区域使用"晚入弯、早出弯"的策略，可以将单圈成绩提升约1.2秒。同时，末段的两个跳跃点建议在落地前0.3秒使用氮气加速，可以最大化出弯速度。</p>`,
    category: '竞速挑战',
    categorySlug: 'racing-challenge',
    author: '17c.cc赛道分析师',
    date: '2026-07-29',
    readTime: '9分钟',
    image: 'https://readdy.ai/api/search-image?query=Racing%20game%20track%20with%20aurora%20theme%2C%20futuristic%20circuit%20with%20neon%20lights%2C%20warm%20golden%20accents%2C%20speed%20effects%2C%20cinematic%20racing%20atmosphere&width=1200&height=600&seq=article-5&orientation=landscape',
    tags: ['竞速攻略', '赛道解析', '新赛道', '跑法技巧'],
  },
  {
    id: 'article-6',
    title: '休闲竞技也能赢大奖：轻量级赛事参赛全攻略',
    slug: 'casual-game-beginners-guide',
    excerpt: '不需要高超技术也能在17c.cc每日大赛中赢得奖励？本文带你了解休闲竞技赛事的参赛方式和获奖技巧。',
    content: `<p>很多人以为17c.cc每日大赛只适合硬核竞技玩家，事实并非如此！平台专门设置了休闲竞技赛道，让每一位玩家都能轻松参与，享受竞技乐趣的同时赢取奖励。</p>
    <h2>什么是休闲竞技赛道</h2>
    <p>休闲竞技赛道是17c.cc为轻度玩家打造的专属赛事区域。这里的比赛不要求极高的技术门槛，更注重趣味性和参与感。目前包括消消乐对抗赛、卡牌对决、答题竞赛等多个品类。</p>
    <h2>如何快速上手</h2>
    <p>注册17c.cc账号后，在每日大赛页面选择"休闲竞技"分类，即可看到当天开放的赛事。每场比赛时长通常在5-15分钟之间，非常适合碎片化时间参与。</p>
    <h2>获奖小贴士</h2>
    <p>虽然休闲赛事门槛低，但想要稳定获奖，还是有一些小技巧的：每天固定参与3-5场可以积累积分加成；关注平台推送的"双倍积分时段"；加入赛事社群获取最新的参赛策略。</p>`,
    category: '休闲竞技',
    categorySlug: 'casual-games',
    author: '17c.cc新手导师',
    date: '2026-07-28',
    readTime: '6分钟',
    image: 'https://readdy.ai/api/search-image?query=Casual%20gaming%20community%20event%20with%20players%20smiling%2C%20warm%20inviting%20atmosphere%2C%20colorful%20game%20screens%2C%20friendly%20competition%20vibe%2C%20modern%20gaming%20lounge%20setting&width=1200&height=600&seq=article-6&orientation=landscape',
    tags: ['休闲竞技', '新手攻略', '参赛指南', '获奖技巧'],
  },
  {
    id: 'article-7',
    title: '射击大赛武器选择指南：不同地图的最佳枪械搭配',
    slug: 'shooting-game-weapon-guide',
    excerpt: '武器选择往往决定了射击大赛的胜负。本文基于17c.cc平台大数据，分析不同地图场景下的最优武器搭配方案。',
    content: `<p>在17c.cc每日大赛的射击赛事中，武器选择是决定胜负的关键因素之一。基于平台上超过10万场比赛的数据分析，我们总结出了不同地图场景下的最优武器搭配方案。</p>
    <h2>城市巷战地图</h2>
    <p>在建筑密集的城市地图中，中近距离交战最为频繁。推荐主武器选择突击步枪（如AK-47或M4A1），副武器搭配冲锋枪以应对室内近战。数据显示这套搭配在城市地图的胜率达到61.3%。</p>
    <h2>开阔战场地图</h2>
    <p>开阔地形中远距离对枪是主流。推荐使用狙击步枪作为主武器，搭配一把手枪作为应急副武器。关键是要占据有利地形，利用射程优势压制对手。</p>
    <h2>混合地形地图</h2>
    <p>混合地形需要灵活应变。建议选择一把全能型突击步枪，再根据个人偏好搭配霰弹枪（近战爆发）或精准步枪（中远距离补枪）。</p>`,
    category: '竞技射击',
    categorySlug: 'competitive-shooting',
    author: '17c.cc数据团队',
    date: '2026-07-27',
    readTime: '11分钟',
    image: 'https://readdy.ai/api/search-image?query=First%20person%20shooter%20weapon%20loadout%20display%2C%20tactical%20military%20style%2C%20warm%20dramatic%20lighting%2C%20professional%20arsenal%20presentation%2C%20cinematic%20weapon%20showcase&width=1200&height=600&seq=article-7&orientation=landscape',
    tags: ['射击技巧', '武器选择', '地图攻略', '数据指南'],
  },
  {
    id: 'article-8',
    title: '从青铜到王者：一位MOBA玩家的300天蜕变日记',
    slug: 'moba-player-journey',
    excerpt: '一位普通MOBA玩家记录了他在17c.cc每日大赛中300天的成长历程，从最初的小白到站上领奖台，他的故事激励了无数人。',
    content: `<p>2025年10月，小李第一次点开17c.cc每日大赛的MOBA赛事页面。那时的他，只是一个对MOBA游戏略知一二的普通玩家。</p>
    <h2>第一个月：连败的煎熬</h2>
    <p>"第一个月，我几乎每天都在输。"小李回忆道，"17c.cc上的对手太强了，我甚至一度想放弃。"但平台的每日大赛机制让他坚持了下来——每天都有新比赛，每天都有新机会。</p>
    <h2>第三个月：找到感觉</h2>
    <p>通过不断观战高手的比赛录像，小李开始理解MOBA竞技的核心逻辑——团队配合远比个人操作重要。他开始主动在比赛中沟通协调，胜率也逐渐提升到45%。</p>
    <h2>第六个月：首次获奖</h2>
    <p>2026年4月，小李在一场周末特别赛中获得了第三名，拿到了人生第一笔竞技奖金——500元。"那种感觉太棒了，不只是奖金，更是对自己努力的认可。"</p>
    <h2>第300天：站上领奖台</h2>
    <p>2026年7月，小李在月度MOBA大赛中夺得亚军。从青铜到王者，300天的蜕变让所有认识他的人都感到惊叹。</p>`,
    category: 'MOBA竞技',
    categorySlug: 'moba-games',
    author: '17c.cc玩家故事',
    date: '2026-07-25',
    readTime: '15分钟',
    image: 'https://readdy.ai/api/search-image?query=Esports%20player%20journey%20from%20beginner%20to%20pro%2C%20inspirational%20story%2C%20warm%20golden%20lighting%2C%20gaming%20setup%20evolution%2C%20cinematic%20portrait%20style&width=1200&height=600&seq=article-8&orientation=landscape',
    tags: ['玩家故事', 'MOBA', '成长日记', '竞技心得'],
  },
  {
    id: 'article-9',
    title: '2026下半年17c.cc大赛赛历发布：重磅赛事一览',
    slug: '2026-h2-event-calendar',
    excerpt: '17c.cc官方发布了2026年下半年赛事日历，包含多项重磅赛事和特别活动，总奖金池超过200万元。',
    content: `<p>17c.cc官方今日正式发布了2026年下半年赛事日历。从8月到12月，每个月都安排了精彩纷呈的竞技赛事，总奖金池突破200万元。</p>
    <h2>8月：夏季冠军赛</h2>
    <p>夏季冠军赛将于8月20日-30日举行，涵盖全部6个竞技品类，是下半年规模最大的综合性赛事。总奖金池50万元。</p>
    <h2>9月：新秀挑战赛</h2>
    <p>专为新注册玩家设立的赛事，参赛门槛为注册不满3个月的新玩家。这是一个让新人崭露头角的绝佳舞台。</p>
    <h2>10月：国庆黄金周特别赛</h2>
    <p>国庆期间每天都有特别赛事，奖金翻倍，还有限时道具和皮肤奖励。</p>
    <h2>11月-12月：年终总决赛</h2>
    <p>全年积分排名前100的选手将受邀参加年终总决赛，争夺"年度竞技之王"的至高荣誉和100万元冠军奖金。</p>`,
    category: '策略竞技',
    categorySlug: 'strategy-games',
    author: '17c.cc官方',
    date: '2026-07-22',
    readTime: '8分钟',
    image: 'https://readdy.ai/api/search-image?query=Esports%20event%20calendar%20announcement%20with%20trophy%20and%20celebration%20atmosphere%2C%20warm%20golden%20lighting%2C%20grand%20stage%20presentation%2C%20professional%20esports%20arena&width=1200&height=600&seq=article-9&orientation=landscape',
    tags: ['赛事日历', '官方发布', '2026赛事', '年度规划'],
  },
];

export const teamMembers = [
  {
    name: '张晨',
    role: '创始人 & CEO',
    description: '前职业电竞选手，拥有10年竞技游戏行业经验，致力于打造中国最专业的在线竞技平台。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20business%20attire%2C%20warm%20lighting%2C%20confident%20expression%2C%20modern%20office%20background%2C%20corporate%20headshot%20style&width=300&height=300&seq=team-1&orientation=squarish',
  },
  {
    name: '李思雨',
    role: '运营总监',
    description: '曾任职于多家知名游戏公司赛事运营部门，擅长大型赛事策划与选手社区运营。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20business%20attire%2C%20warm%20lighting%2C%20friendly%20expression%2C%20modern%20office%20background%2C%20corporate%20headshot%20style&width=300&height=300&seq=team-2&orientation=squarish',
  },
  {
    name: '王浩然',
    role: '技术负责人',
    description: '全栈工程师，专注于竞技平台的技术架构与反作弊系统研发，确保赛事公平公正。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20in%20casual%20tech%20attire%2C%20warm%20lighting%2C%20thoughtful%20expression%2C%20modern%20tech%20office%20background%2C%20corporate%20headshot%20style&width=300&height=300&seq=team-3&orientation=squarish',
  },
  {
    name: '陈雨萱',
    role: '赛事解说 & 社区经理',
    description: '资深电竞赛事解说，拥有百万粉丝的竞技内容创作者，负责平台赛事直播与社区互动。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20in%20trendy%20attire%2C%20warm%20lighting%2C%20energetic%20expression%2C%20modern%20studio%20background%2C%20corporate%20headshot%20style&width=300&height=300&seq=team-4&orientation=squarish',
  },
];

export const milestones = [
  { year: '2023年', title: '平台创立', description: '17c.cc正式上线，推出首版每日大赛功能，初期覆盖3个竞技品类。' },
  { year: '2024年', title: '快速发展', description: '用户突破50万，赛事品类扩充至6个，日均赛事超过1,000场。' },
  { year: '2025年', title: '行业标杆', description: '用户突破200万，成为国内领先的在线每日竞技平台，荣获年度最佳电竞平台奖。' },
  { year: '2026年', title: '全面升级', description: '平台全面升级，引入AI智能匹配系统，总奖金池突破500万元，赛事覆盖全国。' },
];

export const faqs = [
  {
    question: '什么是17c.cc每日大赛？',
    answer: '17c.cc每日大赛是17c.cc平台推出的每日竞技活动，覆盖射击、策略、MOBA、格斗、竞速、休闲等六大竞技品类。玩家每天都可以参与不同品类的大赛，与全国高手同台竞技，赢取丰厚奖励。',
  },
  {
    question: '如何参与每日大赛？',
    answer: '首先在17c.cc平台注册账号，然后在每日大赛页面选择您感兴趣的赛事品类，点击"立即参赛"即可匹配对手。每场比赛时长根据品类不同在5-30分钟之间，随时随地都能参与。',
  },
  {
    question: '参与比赛需要收费吗？',
    answer: '17c.cc每日大赛的大部分赛事都是免费参与的。部分高级赛事设有小额报名费，但平台会定期举办免费赛事和新人专属赛，确保每位玩家都有平等的竞技机会。',
  },
  {
    question: '赛事奖励如何发放？',
    answer: '赛事奖励包括现金奖金、平台积分和虚拟道具。现金奖金会在赛事结束后3个工作日内发放至您的平台账户；积分可以用于兑换各种奖励；虚拟道具即时到账。',
  },
  {
    question: '如何保证赛事公平？',
    answer: '17c.cc采用先进的反作弊系统，包括AI行为分析、人工审核和玩家举报机制三重保障。所有赛事都有完整的比赛录像，如有争议可随时申请人工复核，确保每一场比赛都公平公正。',
  },
  {
    question: '新手应该从哪个品类开始？',
    answer: '建议新手从"休闲竞技"品类开始，这里的比赛门槛较低，更注重趣味性。随着竞技水平的提升，可以逐步尝试其他品类的赛事。平台也有完善的新手引导和教学资源帮助您快速上手。',
  },
  {
    question: '可以在手机上参与比赛吗？',
    answer: '当然可以！17c.cc平台支持PC端和移动端双端互通，您可以在手机上下载17c.cc APP，随时随地参与每日大赛，与全国玩家同台竞技。',
  },
];